import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Comentario } from '../models/comentario.model';
import { Page } from '../models/page.model';

@Injectable({
    providedIn: 'root'
})
export class ComentarioService extends BaseService<Comentario> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/comentario`, injector);
    }

    getByEstimativaId(estimativaId: number): Observable<Page<Comentario>> {
        return this.http.get<Page<Comentario>>(`${environment.API_PRICE}/comentario/getByEstimativaId/${estimativaId}`);
    }

    updateByEstimativaId(comentario: Comentario): Observable<Page<Comentario>> {
        return this.http.put<Page<Comentario>>(`${environment.API_PRICE}/comentario/Update`, comentario);
    }

    desativarComentarioByComentarioId(comentarioId: number): Observable<Page<Comentario>> {
        return this.http.put<Page<Comentario>>(`${environment.API_PRICE}/comentario/DesativarComentario`, comentarioId);
    }
}